import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Grid, Paper, Button } from '@material-ui/core';
import { CircularProgress, Typography, Divider } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import TextField from 'components/Form/TextField';
import text from 'texts/translations';
import { Link } from 'react-router-dom';

import TemplateEditor from '../../components/TemplateEditor/TemplateEditor';

import styles from '../App.css';
import componentStyles from '../CreateUser/CreateUser.css';
import { withSnackbar } from 'notistack';
import Translation from '../../components/Translation/Translation';

//create new user account
@inject('formDataStore')
@observer
class CreateTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      template: {
        name: '',
        html: ''
      }
    };

    this.updateProperty = this.updateProperty.bind(this);
  }

  updateProperty(key, value) {
    var template = this.state.template;
    template[key] = value;

    this.setState({template});
  }

  create() {
    this.props.customerCaseStore.createTemplate(this.state.template)
      .then((data) => {
        if (data.errors) {
          throw data;
        }

        this.props.enqueueSnackbar(<Translation>action.create_success</Translation>, {variant: 'success'})
        this.props.history.push('/templates');
      })
      .catch(() => this.props.enqueueSnackbar(<Translation>action.create_failed</Translation>, {variant: 'error'}));
  }

  renderData() {
    return (
      <Grid item xs={12}>
        <Grid item xs={12}>
          <TextField
            id="name"
            helperText={<Translation>template.name</Translation>}
            value={this.state.template.name}
            onChange={event => {
              this.updateProperty('name', event.target.value);
            }}

            style={componentStyles.textField}
          />
        </Grid>

        <Grid item xs={12}>
          <small for="html"><Translation>template.html</Translation></small>
          <TemplateEditor
            id="html"
            value={this.state.template.html}
            onValueChange={value => {
              this.updateProperty('html', value);
            }}
          />
        </Grid>

        <Button
          variant="raised"
          color="primary"
          onClick={this.create.bind(this)}>
          <Translation>add</Translation>
        </Button>
      </Grid>
    );
  }

  render() {
    return (
      <Grid item xs={12}>
        <Paper style={styles.paper}>{this.renderData()}</Paper>
      </Grid>
    );
  }
}

export default withSnackbar(CreateTemplate);



// WEBPACK FOOTER //
// ./src/views/CreateTemplate/CreateTemplate.jsx